// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueTheMask from 'vue-the-mask'

import config from '../../config';
import {Auth} from '@/services';

import './styles.scss';

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV == 'development';

import prLogin from './loginComponent';

Vue.use(VueTheMask);
Vue.component('pr-login', prLogin);

Auth.init().then(() => {
  new Vue({
    el: '#prLogin',
		data: {
			app: {
				busy: false
			}
		},
		beforeCreated() {
			this.app.busy = true;
		},
		ready() {
			this.app.busy = false
		}
  })
});



// WEBPACK FOOTER //
// ./src/external/index.js